import React, { useEffect } from "react";
import { useSelector } from 'react-redux';

import commonComponents from "../../components/common";

import common from "../../utils/common";
import global from "../../config/global";

const Login = () => {
  const { BusyOverlay } = commonComponents;
  const locale = useSelector((state) => state.system.locale);

  const query = common.convertStringToQuery(window.location.search);

  useEffect(() => {
    window.location.replace(`${global.urls.LOCKER_ID_URL}/login?SERVICE_URL=${query?.return_url || '/'}&SERVICE_SCOPE=${global.constants.SERVICE_SCOPE}&ENVIRONMENT=${global.constants.ENVIRONMENT}&lang=${query?.lang || locale}`)
  }, [locale])
  return (
    <div className="auth-page items-center">
      <BusyOverlay />
    </div>
  );
}

export default Login;